import React from 'react';
import styles from './FeaturedDesigners.module.scss';

const MAX_STARS = 4;
const GOLD = '#dece71';
const EMPTY = '#e5e3d0';

interface IStarsProps {
  rating: number;
}

export default function Stars({ rating }: IStarsProps) {
  const clamped = Math.max(0, Math.min(MAX_STARS, rating));
  return (
    <div
      className={styles.Stars}
      role="img"
      aria-label={`Rated ${clamped} out of ${MAX_STARS}`}
    >
      {Array.from({ length: MAX_STARS }, (_, i) => {
        const fill = Math.max(0, Math.min(1, clamped - i));
        const gradientId = `star-${i}-${fill}`;
        return (
          <svg
            key={i}
            className={styles.Star}
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <defs>
              <linearGradient id={gradientId}>
                <stop offset={`${fill * 100}%`} stopColor={GOLD} />
                <stop offset={`${fill * 100}%`} stopColor={EMPTY} />
              </linearGradient>
            </defs>
            <path
              d="M12 2l2.39 7.36H22l-6.31 4.58L18.08 21 12 16.42 5.92 21l2.39-7.06L2 9.36h7.61z"
              fill={`url(#${gradientId})`}
            />
          </svg>
        );
      })}
      <span className={styles.StarsLabel}>/{MAX_STARS}</span>
    </div>
  );
}
